<template>
    <div id="chuangPersonnel">
        <div class="row hide-on-med-and-down">
            <div class="col s12 m6 l6 xl6">
                <div class="personnel-container-img">
                    <img src="../assets/images/personnel-bg.png" alt="">
                </div>
            </div>
            <div class="col s12 m6 l6 xl6">
                <div :class="{'personnel-recruitment-container':true} ">
                    <h5>{{personnelLanguages[selectedLanguage]}}</h5>
                    <p class="description" v-html="personnelDescription[selectedLanguage]"></p>
                    <div class="col m12 l6 xl6">
                        <ul>
                            <li v-for="item in personnelRecruitmentLists1[selectedLanguage]" :key="item.id">
                                {{ "&#9679 " + item }}
                            </li>
                        </ul>
                    </div>
                    <div class="col m12 l6 xl6">
                        <ul>
                            <li v-for="item in personnelRecruitmentLists2[selectedLanguage]" :key="item.id">
                                {{ "&#9679 " + item }}
                            </li>
                        </ul>
                    </div>
                    <div class="info-btn-container">
                        <a href="https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=414b456e5f6d4a6845593b21572f37608393b436c35373f683d433b1e1e1e1e631473b613270j49&jobsource=n104bank1">
                            <button v-text="infoButtonTestList[selectedLanguage]"></button>
                        </a>
                    </div>

                </div>
            </div>
        </div>
        <div class="row hide-on-large-only">
            <div class="col s12 m12">
                <div :class="{'personnel-recruitment-container':true}">
                    <h5>{{personnelLanguages[selectedLanguage]}}</h5>
                    <p class="description" v-html="personnelDescription[selectedLanguage]"></p>
                    <div class="col m6 l6 xl6">
                        <ul>
                            <li v-for="item in personnelRecruitmentLists1[selectedLanguage]" :key="item.id">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                    <div class="col m6 l6 xl6">
                        <ul>
                            <li v-for="item in personnelRecruitmentLists2[selectedLanguage]" :key="item.id">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                    <div class="info-btn-container">
                        <a href="https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=414b456e5f6d4a6845593b21572f37608393b436c35373f683d433b1e1e1e1e631473b613270j49&jobsource=n104bank1">
                            <button v-text="infoButtonTestList[selectedLanguage]"></button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isAnimateChangeLanguageOn: false,
                personnelLanguages: ['招聘人才', '招聘人才', 'PERSONNEL RECRUITMENT'],
                personnelRecruitmentLists1:
                [
                    [
                        'DBA(SQL Server)資料庫管理員',
                        'Android資深工程師',
                        'iOS資深工程師',
                        '資深C++軟體工程師',
                        'WEB前端工程師', 
                    ],
                    [
                        'DBA(SQL Server)数据库管理员 ',
                        'Android资深工程师',
                        'iOS资深工程师',
                        '资深C++软件工程师 ',
                        'WEB前端工程师', 
                    ],
                    [
                        'Database Analyst (SQL Server)',
                        'Android Senior Engineer',
                        'iOS Senior Engineer',
                        'C++ Software Engineer',
                        'Web Front End Engineer', 
                    ]
                ],
                personnelRecruitmentLists2:
                [
                    [
                    '系統工程師(MIS)',
                    'JAVA 軟體工程師',
                    '產品經理 (Product Manager)',
                    '軟體測試工程師',
                    '遊戲美術設計師'
                    ],
                    [

                    '系统工程师(MIS) ',
                    'JAVA 软件工程师 ',
                    '产品经理 (Product Manager) ',
                    '软件测试工程师',
                    '游戏美术设计师 '
                    ],
                    [
                    'System Engineer (MIS)',
                    'Java Software Engineer',
                    'Product Manager',
                    'Software  Quality Assurance Manager',
                    'Game Artist'
                    ]
                ],
                infoButtonTestList: ['詳細連結', '详细连结', 'More Details'],
                personnelDescription: 
                [
                     'WORK HARD, PLAY HARD!<br>充滿活力的創樂科技提供具競爭性『薪酬』與超豐厚『福利』禮遇首先提供更從容的上班時間，公司採彈性上班制08:30AM~09:30AM，便利舒適的優質辦公室環境，搭配豐富零食與香醇可口的現煮咖啡，創作自己的職涯生活，除了上班時的活力，擁有頂尖優秀的團隊，有你的加入，將會更加強大，歡迎對軟體科技業充滿熱情且對自我工作能力充滿自信的你！',
                    'WORK HARD, PLAY HARD!<br>充满活力的创乐科技提供具竞争性『薪酬』与超丰厚『福利』礼遇首先提供更从容的上班时间，公司采弹性上班制08:30AM~09:30AM，便利舒适的优质办公室环境，搭配丰富零食与香醇可口的现煮咖啡，创作自己的职涯生活，除了上班时的活力，拥有顶尖优秀的团队，有你的加入，将会更加强大，欢迎对软件科技业充满热情且对自我工作能力充满自信的你！',
                    'WORK HARD, PLAY HARDER!<br>Chuangle provides competitive salary and  a generous compensation package.Flexible office hours. You can come to work from 08:30AM~09:30AM. Convenient and comfortable working environment with ample snacks and endless flow of brewed coffee. Create your own career with a great team. With you in our team, we will  be greater. If you are passionate with technology and confident with your skills, join us!'
                ],
                recruitmentLists:
                [
                    [
                        'DBA(SQL Server)資料庫管理員',
                        'Android資深工程師',
                        'iOS資深工程師',
                        '資深C++軟體工程師',
                        'WEB前端工程師', 
                        '系統工程師(MIS)',
                        'JAVA 軟體工程師',
                        '產品經理',
                        '軟體測試工程師',
                        '遊戲美術設計師'
                    ],
                    [
                        'DBA(SQL Server)数据库管理员 ',
                        'Android资深工程师',
                        'iOS资深工程师',
                        '资深C++软件工程师 ',
                        'WEB前端工程师', 
                        '系统工程师(MIS) ',
                        'JAVA 软件工程师 ',
                        '产品经理 (Product Manager) ',
                        '软件测试工程师',
                        '游戏美术设计师 '
                    ],

                    [
                        'Database Analyst (SQL Server)',
                        'Android Senior Engineer',
                        'iOS Senior Engineer',
                        'C++ Software Engineer',
                        'Web Front End Engineer', 
                        'System Engineer (MIS)',
                        'Java Software Engineer',
                        'Product Manager',
                        'Software  Quality Assurance Manager',
                        'Game Artist'
                    ]
                ],

                selectedLanguage: 0
            }
        },
        methods: {
            startChangeLangAnimation(){
                let _this = this;
                this.isAnimateChangeLanguageOn = true;
                setTimeout(function() {
                    _this.isAnimateChangeLanguageOn = false;
                }, 1);
            },
        },
        mounted: function() {
            let _this = this;
            this.$root.$on('languageChange', function(e){
                _this.selectedLanguage = parseInt(e);
            })
            this.$root.$off('animageChangeLanguage', function(e){
                 _this.startChangeLangAnimation();
            })
            window.addEventListener('resize', function(e){
                let h = document.getElementById('chuangPersonnel').offsetHeight;
                _this.$root.$emit('updatePerSize', h)
            });
             window.addEventListener('load', function(e){
                let h = document.getElementById('chuangPersonnel').offsetHeight;
                _this.$root.$emit('updatePerSize', h)
            });
        },
    }
</script>

<style lang="less" scoped>
@import url('../assets/css/base.less');

    .overwrite-row {
        margin-bottom: none!important;
    }
    
    #chuangPersonnel {
        min-width: auto;
        padding-right: 5rem;
        padding-left: 5rem;
        padding-top: 6rem;
        padding-bottom: 6rem;
        @media @990 {
            background: url('../assets/images/personnel-bg-mobile.png') no-repeat center;
            background-size: cover; 
            padding-right: 2rem;
            padding-left: 2rem;
        }
        @media @768 {
            background: url('../assets/images/personnel-bg-mobile.png') no-repeat center;
            background-size: cover; 
            padding-right: 2rem;
            padding-left: 2rem;
        }
        @media @479 {
            background: url(/static/img/personnel-bg-mobile.40ceffc.png) no-repeat bottom;
            background-size: 100%;
            padding-right: 2rem;
            padding-left: 2rem;
            padding-top: 3rem;
        }
    }

    .personnel-container-img {

        img {
            width: 100%;
            padding-right: 3rem;

        }
    }
    .personnel-recruitment-container {
        color: #535353;
        width: 55rem;
        @media @1920 {
            width: 55rem;
        }
        @media @1600 {
            width: 45rem;
        }
        @media @1400 {
            width: 40rem;
        }
        @media @1200 {
    
        }
        @media @990 {
            width: 40rem;
            margin: 0rem auto;
        }
        @media @768 {
            width: 45rem;
            margin: 0rem auto;
        }
        @media @479 {
            margin: 0rem auto;
            width: 20rem;
        }
        @media @360 {
            margin: 0rem auto;
            width: 20rem;
        }
        @media @320 {
            margin: 0rem auto;
            width: 18rem;
        }
        h5 {
            margin-top: 2rem;
            margin-bottom: 2rem;
            text-align: left;
            font-size: 1.7rem;
            padding-left: 1rem; 
            @media @1920 {
                margin-top: 2rem;
                margin-bottom: 2rem;
                font-size: 1.7rem;
                text-align: left;
            }
            @media @1600 {
                margin-bottom: 2rem;
                text-align: left;
                font-size: 1.7rem;
            }
            @media @1400 {
                margin-bottom: 2rem;
                text-align: left;
                font-size: 1.7rem;
            }
            @media @1200 {
                margin-bottom: 2rem;
                text-align: left;
                font-size: 1.7rem;
            }
            @media @990 {
                margin-bottom: 2rem;
                text-align: center;
                font-size: 1.7rem;
            }
            @media @768 {
                margin-bottom: 2rem;
                text-align: center;
                font-size: 1.7rem;
            }
            @media @479 {
                margin-top: 0rem;
                margin-bottom: 2rem;
                text-align: center;
                font-size: 1.7rem;
            }
        }
        ul {
            
            li {
                font-size: @cons-description-text-size-1920;
                line-height: 4rem;
                @media @1920 {
                    font-size: @cons-description-text-size-1920;
                    line-height: 4rem;
                }
                @media @1600 {
                    font-size: @cons-description-text-size-1920;
                    line-height: 3rem;
                }
                @media @1400 {
                    font-size: @cons-description-text-size-1920;
                    line-height: 2.5rem;
                }
                @media @1200 {
                    font-size: @cons-description-text-size-1920;
                    line-height: 2.2rem;
                }
                @media @990 {
                    font-size: @cons-description-text-size-1920;
                    line-height: 3.2rem;
                    line-height: 1.7rem;
                    margin-bottom: 1rem;
                }
                @media @768 {
                    font-size: @cons-description-text-size-1920;
                    line-height: 3rem;
                    line-height: 1.7rem;
                    margin-bottom: 1rem;
                }
                @media @479 {
                    font-size: @cons-description-text-size-1920;
                    line-height: 1.7rem;
                    margin-bottom: 1rem;
                }
            }

        }
        .info-btn-container {
            padding-left: 1rem;
            @media @990 {
                width: 16rem;
                margin: 0 auto;
            }
            @media @768 {
                width: 16rem;
                margin: 0 auto;
            }
            @media @479 {
                width: 16rem;
                margin: 0 auto;
            }
        }
        button {
            width: 18rem;
            cursor: pointer;
            margin-top: 1rem;
            -webkit-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.75);
            -moz-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.75);
            box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.75);
            border-radius: 25px 25px 25px 25px;
            -moz-border-radius: 25px 25px 25px 25px;
            -webkit-border-radius: 25px 25px 25px 25px;
            border: 0px solid #000000;
            background: url('../assets/images/info-button.png') no-repeat center;
            color: #fff;
            padding-bottom: 0.5rem;
            padding-top: 0.5rem;
            font-size: @cons-description-text-size-1920;
            @media @1920 {
                margin-top: 1rem;
                width: 17rem;
            }
            @media @1600 {
                margin-top: 1rem;
                width: 17rem;
            }
            @media @1400 {
                margin-top: 1rem;
                width: 17rem;
            }
            @media @1200 {
                margin-top: 1rem;
                width: 17rem;               
            }
            @media @990 {
                margin-top: 1rem;
                width: 17rem;
            }
            @media @768 {
                margin-top: 1rem;
                width: 16rem;

            }
            @media @479 {
                margin-top: 1rem auto;
                width: 15rem;
            }
            
        }
        .description {
            font-size: 1.5rem;
            margin-bottom: 30px;
            padding-left: 1rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ChuangPersonnel.vue